"use client"

/**
 * useAuth Hook
 * Access auth state and methods from anywhere in the app
 * Re-exports the AuthContext functionality for convenience
 */

import { useAuthContext } from "../context/AuthContext"

export function useAuth() {
  return useAuthContext()
}

// Also export individual properties for more granular imports
export function useUser() {
  const { user } = useAuthContext()
  return user
}

export function useAuthLoading() {
  const { loading } = useAuthContext()
  return loading
}

export function useSignIn() {
  const { signIn } = useAuthContext()
  return signIn
}

export function useSignUp() {
  const { signUp } = useAuthContext()
  return signUp
}

export function useSignOut() {
  const { signOut } = useAuthContext()
  return signOut
}